import { Freeze } from 'react-freeze'
import { CSSProperties, forwardRef, ReactNode, RefObject } from 'react'
import { isPhoneOrTablet, SIMULATED_PHONE_WIDTH } from '$func/environmentInfo'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import {
  safeAreaCssVariables,
  viewportHeightConsideringNotch,
  viewportHeight,
  stickToTopTransform,
} from '$setup/visual-viewport'

export const OVERLAY_PANEL_Z_INDEX_FACTOR = 20

export const VisibilityHandler = forwardRef(
  (
    {
      children,
      zIndex,
      considerIOSNotch = false,
      freezeChildren,
      style,
    }: {
      children: ReactNode
      zIndex: number
      considerIOSNotch?: boolean
      freezeChildren?: boolean
      style?: CSSProperties
    },
    ref,
  ) => {
    const isDesktop = useIsDesktopSize()

    return (
      <div
        ref={ref as RefObject<HTMLDivElement>}
        style={{
          zIndex,
          position: !isDesktop || isPhoneOrTablet ? 'fixed' : 'static',

          ...(considerIOSNotch
            ? {
                top: safeAreaCssVariables.insetTop,
                left: safeAreaCssVariables.insetLeft,
                right: safeAreaCssVariables.insetRight,
                height: viewportHeightConsideringNotch,
              }
            : {
                top: 0,
                left: 0,
                right: 0,
                height: viewportHeight,
              }),
          transform: stickToTopTransform,
          overflow: 'hidden',
          pointerEvents: freezeChildren ? 'none' : 'auto',

          // TODO: Keep this till implementing desktop layout
          ...(!isPhoneOrTablet && !isDesktop
            ? {
                maxWidth: SIMULATED_PHONE_WIDTH,
                margin: 'auto',
              }
            : null),

          ...style,
        }}
      >
        <Freeze
          freeze={typeof freezeChildren !== 'undefined' && freezeChildren}
        >
          {children}
        </Freeze>
      </div>
    )
  },
)
